import { RootState } from "../../../../store";
import { RecommendationGroupType } from "../../../../../components/pages/recommendations/components/off-hours-recommendations/utils/types/types";
import { getUsersMeOrganisationsCurrentDismissedResourcesSelector } from "../../dismiss/resources/getUsersMeOrganisationsCurrentDismissedResourcesSelector";
import { GetUsersMeOrganisationsCurrentDismissedResourcesApiResponse } from "../../../../../services/cloudchipr.api";

export const offHoursRecommendationsDismissedResourcesDataByGroupSelector = (
  state: RootState,
  group: RecommendationGroupType,
): GetUsersMeOrganisationsCurrentDismissedResourcesApiResponse | undefined => {
  const response = getUsersMeOrganisationsCurrentDismissedResourcesSelector({
    group,
    recommendationType: "off_hours",
  })(state);

  return response?.data;
};
